import classNames from 'classnames';
import React, { useCallback } from 'react';
import { forTemplate } from '@trello/i18n';
import { useLocation } from '@trello/router';
import { escapeReturnUrl } from '@trello/urls';
import { Analytics } from '@trello/atlassian-analytics';
import { useAnalyticsAttributes } from './AnalyticsAttributesProvider';
import styles from './Buttons.less';

const format = forTemplate('logged_out_header');

interface ButtonsProps {
  onLoginClick?: () => void;
  onSignupClick?: () => void;
}

export const Buttons: React.FunctionComponent<ButtonsProps> = ({
  onLoginClick,
  onSignupClick,
}) => {
  const { pathname } = useLocation();
  const returnUrl = escapeReturnUrl(pathname);
  const analyticsAttributes = useAnalyticsAttributes();

  const logInText = format('log-in');
  const signUpText = format('sign-up');

  const onClickLogin = useCallback(() => {
    Analytics.sendClickedLinkEvent({
      linkName: 'logInLink',
      source: 'anonymousHeader',
      attributes: {
        ...analyticsAttributes,
        event: 'clicked',
        eventComponent: 'globalNavButton',
        label: logInText,
        href: '/login',
        isMarketingEvent: true,
      },
    });
    if (onLoginClick) {
      onLoginClick();
    }
  }, [analyticsAttributes, logInText, onLoginClick]);

  const onClickSignup = useCallback(() => {
    Analytics.sendClickedLinkEvent({
      linkName: 'getTrelloForFreeLink',
      source: 'anonymousHeader',
      attributes: {
        ...analyticsAttributes,
        event: 'clicked',
        eventComponent: 'globalNavButton',
        label: signUpText,
        href: '/signup',
        isMarketingEvent: true,
      },
    });
    if (onSignupClick) {
      onSignupClick();
    }
  }, [analyticsAttributes, signUpText, onSignupClick]);

  return (
    <div className={styles.buttonGroup}>
      <a
        className={styles.buttonLink}
        href={`/login?returnUrl=${returnUrl}`}
        onClick={onClickLogin}
      >
        {logInText}
      </a>
      <a
        className={classNames(styles.buttonLink, styles.primaryButtonLink)}
        href={`/signup?returnUrl=${returnUrl}`}
        onClick={onClickSignup}
      >
        {signUpText}
      </a>
    </div>
  );
};
